<template>
  <div id="layout">
    <el-container class="layoutBg">
      <el-header class="commont-header-container" height="60px">
        <div style="width: 100%">
          <div class="logo-container">
            <div class="header-left_icon">
              <img class="logo-img-top" v-if="project == 'bby'" src="@/assets/logo2.png" alt />
              <img class="logo-img-top" v-else src="@/assets/logo2.png" alt />
            </div>

            <div class="header-right_content">
              <!-- <div class="header_title">欢迎登录</div> -->
              <div class="header-current_time">{{ date | zhDatetime }}</div>
              <div class="header-right_user">
                <!-- <div class="user-head_portrait">

                </div>-->
                <!-- <el-avatar size="medium" src="https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png" class="user-header-img"></el-avatar> -->
                <img style="margin-left: 1rem; width: 1.8rem; height: 1.8rem; cursor: pointer" src="~@/assets/头像 copy 2.png" alt="" />
                <div class="user-fun-container">
                  <el-dropdown>
                    <span class="el-dropdown-link" style="display: flex; align-items: center">
                      <span style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; color: #ffffff; display: block">{{ user_name }}</span>
                      <i style="line-height: 60px; color: #ffffff" class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu class="user-funDropdown-container" slot="dropdown">
                      <el-dropdown-item @click.native="changePassowrd()">
                        <span class="FontFamily el-icon-erp el-icon-erp-changepassword"></span>
                        <span class="user-fun-text">修改密码</span>
                      </el-dropdown-item>
                      <el-dropdown-item @click.native="loginOut()">
                        <span class="FontFamily el-icon-erp el-icon-erp-tuichu"></span>
                        <span class="user-fun-text">退出系统</span>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
              <!-- <div class="header_title"> 帮助</div> -->
              <div style="margin-left: 1rem; cursor: pointer; font-size: 15px" v-if="userType != 3" @click="$router.push({ path: '/homePage1' })" class="header_title">返回首页</div>
              <div style="margin-left: 1rem; cursor: pointer; font-size: 15px" v-if="userType == 3" @click="getTo_xt" class="header_title">帮助文档</div>
            </div>
          </div>
          <div class="labelPage">
            <div class="header-center_tab">
              <el-menu class="el-menu-demo" mode="horizontal" @select="handleSelect" :default-active="$route.path" router v-if="userType != 3">
                <template>
                  <el-menu-item v-allowy="'01'" @click="titleShow(1)" index="/homePage" style="z-index: 9; height: 45px; line-height: 45px; border-bottom: none; color: #ffffff; font-weight: bold; background: none">
                    <div class="home_item" :class="colorShow == 1 ? 'colorShow' : ''">
                      <!-- <img src="@/static/iconImg/homeB.png" style="margin-right: 5px" alt v-show="colorShow != 1" />
                      <img src="@/static/iconImg/homeW.png" style="margin-right: 5px" alt v-show="colorShow == 1" /> -->
                      实时监测
                    </div>
                  </el-menu-item>
                  <el-menu-item v-allowy="'02'" @click="titleShow(2)" style="z-index: 8; height: 45px; line-height: 45px; border-bottom: none; color: #ffffff; font-weight: bold; background: none" index="/intelligentControl" :class="colorShow == 2 ? 'colorShow' : ''">
                    <div class="home_item" :class="colorShow == 2 ? 'colorShow' : ''">远程控制模式</div>
                  </el-menu-item>
                  <el-menu-item v-allowy="'03'" @click="titleShow(8)" index="/decisionManagement" style="z-index: 7; height: 45px; line-height: 45px; border-bottom: none; color: #ffffff; font-weight: bold; background: none" :class="colorShow == 8 ? 'colorShow' : ''">
                    <div class="home_item" :class="colorShow == 8 ? 'colorShow' : ''">
                      <!-- <img src="@/static/iconImg/jueceB.png" style="margin-right: 5px" alt v-show="colorShow != 8" />
                      <img src="@/static/iconImg/jueceW.png" style="margin-right: 5px" alt v-show="colorShow == 8" /> -->
                      AI自动模式
                    </div>
                  </el-menu-item>
                  <el-menu-item v-allowy="'08'" @click="titleShow(15)" index="/timedTask" style="z-index: 7; height: 45px; line-height: 45px; border-bottom: none; color: #ffffff; font-weight: bold; background: none" :class="colorShow == 8 ? 'colorShow' : ''">
                    <div class="home_item" :class="colorShow == 15 ? 'colorShow' : ''">
                      <!-- <img src="@/static/iconImg/jueceB.png" style="margin-right: 5px" alt v-show="colorShow != 8" />
                      <img src="@/static/iconImg/jueceW.png" style="margin-right: 5px" alt v-show="colorShow == 8" /> -->
                      定时控制模式
                    </div>
                  </el-menu-item>
                  <el-menu-item v-allowy="'04'" @click="titleShow(13)" index="/growthModelHisParamControlChart" style="z-index: 7; height: 45px; line-height: 45px; border-bottom: none; color: #ffffff; font-weight: bold; background: none" :class="colorShow == 8 ? 'colorShow' : ''">
                    <div class="home_item" :class="colorShow == 13 ? 'colorShow' : ''">
                      <!-- <img src="@/static/iconImg/jueceB.png" style="margin-right: 5px" alt v-show="colorShow != 8" />
                      <img src="@/static/iconImg/jueceW.png" style="margin-right: 5px" alt v-show="colorShow == 8" /> -->
                      数据分析
                    </div>
                  </el-menu-item>
                  <el-menu-item v-allowy="'05'" @click="titleShow(14)" index="/groupFarm" style="z-index: 7; height: 45px; line-height: 45px; border-bottom: none; color: #ffffff; font-weight: bold; background: none" :class="colorShow == 8 ? 'colorShow' : ''">
                    <div class="home_item" :class="colorShow == 14 ? 'colorShow' : ''">
                      <!-- <img src="@/static/iconImg/jueceB.png" style="margin-right: 5px" alt v-show="colorShow != 8" />
                      <img src="@/static/iconImg/jueceW.png" style="margin-right: 5px" alt v-show="colorShow == 8" /> -->
                      农事记录
                    </div>
                  </el-menu-item>
                  <!-- <el-menu-item @click="getTo" index="/dataAnalysisManagement" style="z-index: 5;height: 45px;line-height: 45px;border-bottom: none;color: #FFFFFF;font-weight: bold;background:none;" :class="colorShow == 5 ? 'colorShow' : ''">
                    <div class="home_item" :class="colorShow == 5 ? 'colorShow' : ''" v-allowy="'05'">

                      数据分析
                    </div>
                  </el-menu-item> -->

                  <el-menu-item v-allowy="'06'" @click="titleShow(7)" index="/alarmPredictions" style="z-index: 8; height: 45px; line-height: 45px; border-bottom: none; color: #ffffff; font-weight: bold; background: none" :class="colorShow == 7 ? 'colorShow' : ''">
                    <div class="home_item" :class="colorShow == 7 ? 'colorShow' : ''">
                      <!-- <img src="@/static/iconImg/yujinB.png" style="margin-right: 5px" alt v-show="colorShow != 7" />
                      <img src="@/static/iconImg/yujinW.png" style="margin-right: 5px" alt v-show="colorShow == 7" /> -->
                      告警管理
                    </div>
                  </el-menu-item>

                  <!-- <el-menu-item @click="titleShow(3)" index="/fertilizerManagement" style="z-index: 7 ;height: 45px;line-height: 45px;border-bottom: none;color: #FFFFFF;font-weight: bold;background:none;" :class="colorShow == 3 ? 'colorShow' : ''">
                    <div class="home_item" :class="colorShow == 3 ? 'colorShow' : ''" v-allowy="'03'">

                      水肥一体化
                    </div>
                  </el-menu-item> -->

                  <el-menu-item v-allowy="'07'" @click="titleShow(10)" index="/deviceManagement" style="z-index: 6; height: 45px; line-height: 45px; border-bottom: none; color: #ffffff; font-weight: bold; background: none" :class="colorShow == 10 ? 'colorShow' : ''">
                    <div class="home_item" :class="colorShow == 10 ? 'colorShow' : ''">
                      <!-- <img src="@/static/iconImg/shebeiB.png" style="margin-right: 5px" alt v-show="colorShow != 10" />
                      <img src="@/static/iconImg/shebeiW.png" style="margin-right: 5px" alt
                        v-show="colorShow == 10" /> -->
                      设备管理
                    </div>
                  </el-menu-item>
                  <!-- <el-menu-item @click="titleShow(4)" index="/growthModel" style="z-index: 6;height: 45px;line-height: 45px;border-bottom: none;color: #FFFFFF;font-weight: bold;background:none;" :class="colorShow == 4 ? 'colorShow' : ''">
                    <div class="home_item" :class="colorShow == 4 ? 'colorShow' : ''" v-allowy="'08'">

                      环境模型
                    </div>
                  </el-menu-item> -->
                  <el-menu-item v-allowy="'09'" @click="titleShow(12)" index="/userManagement" style="z-index: 4; height: 45px; line-height: 45px; border-bottom: none; color: #ffffff; font-weight: bold; background: none" :class="colorShow == 12 ? 'colorShow' : ''">
                    <div class="home_item" :class="colorShow == 12 ? 'colorShow' : ''">
                      <!-- <img src="@/static/iconImg/xitongguanliB.png" style="margin-right: 5px" alt
                        v-show="colorShow != 12" />
                      <img src="@/static/iconImg/xitongguanliW.png" style="margin-right: 5px" alt
                        v-show="colorShow == 12" /> -->
                      系统管理
                    </div>
                  </el-menu-item>
                </template>
              </el-menu>
            </div>
          </div>
        </div>

        <!-- <div class="logo-container">
          <div class="header-right_time"></div>
          <div class="header-right_user"></div>
        </div>-->

        <!-- <vue-scroll :ops="ops">
          <sideMenu ref="sideMenu" @changeTitle="changePositionTitle( $event )"></sideMenu>
        </vue-scroll>-->
      </el-header>

      <el-container style="background: transparent !important">
        <el-main>
          <!-- 当前所处位置 -->
          <!-- <div class="position-info-title-container">
            <el-breadcrumb separator="/">
              <el-breadcrumb-item
                v-for=" ( item , key ) in positionData "
                :key="key"
              >{{ item.title }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="current-page-title-container"></div>
            <div class="position-info-title-right"></div>
          </div>-->
          <!-- <el-scrollbar> -->

          <div class="router-view-container">
            <router-view @func="getMsgFormSon" />
          </div>
          <!-- </el-scrollbar> -->
        </el-main>
        <!-- <el-footer>
          <Foot></Foot>
        </el-footer>-->
      </el-container>
    </el-container>
    <changePassowrd ref="passowrd"></changePassowrd>
  </div>
</template>
<script>
import store from '@/store/index'

import { mapState } from 'vuex'
import changePassowrd from '@/views/home/changePassowrd'
// import changePassowrd from '../../views/home/cha`ngePassowrd'
import sideMenu from './sideMenu'
export default {
  name: 'layout',

  components: {
    changePassowrd,
    sideMenu
  },
  inject: ['reload'],

  data() {
    return {
      project: this.$project,
      homePageIsShow: true,
      date: new Date(),
      positionTitle: '系统首页',
      defaultRouter: '',
      currentPath: '', // 当前路由
      selectCurrentYear: new Date(), // 波段列表保存切换的年份
      positionData: [],
      warningList: [],
      ops: {
        vuescroll: {
          mode: 'native',
          sizeStrategy: 'percent',
          detectResize: true
        },
        scrollPanel: {
          initialScrollY: false,
          initialScrollX: false,
          scrollingX: true,
          scrollingY: true,
          speed: 300,
          easing: undefined,
          verticalNativeBarPos: 'right'
        },
        rail: {
          background: '#01a99a',
          opacity: 0,
          size: '6px',
          specifyBorderRadius: false,
          gutterOfEnds: null,
          gutterOfSide: '2px',
          keepShow: false
        },
        bar: {
          showDelay: 500,
          onlyShowBarOnScroll: true,
          keepShow: false,
          background: '#c1c1c1',
          opacity: 1,
          hoverStyle: false,
          specifyBorderRadius: false,
          minSize: false,
          size: '6px',
          disable: false
        }
      },
      options: [],
      value: '番茄大棚002',
      isCollapse: false, // 是否需要折叠菜单( 这里控制logo是否显示精简图标 )
      colorShow: 1,
      msgFormSon: '',
      userType: 0 // 用户类型（-1 超级管理员，0管理员，1测试用户，2普通用户，3专家用户）
    }
  },

  created() {
    this.permissionJudge() // 调用权限判断方法
    this.user_name = sessionStorage.getItem('USER_name')
    this.userType = sessionStorage.getItem('USER_Type')
    this.defaultRouter = this.$route.path
  },
  beforeUpdate() {
    // 监听vuex 数据变化
  },
  methods: {
    getTo_xt() {
      window.open('https://futurefarm.bbyiot.com/agriculture_develop_webservice/static//pdf/1712717804428.pdf')
      // this.$router.push({
      //   name: 'userManagement'
      // })
    },
    changePassowrd() {
      // 修改密码
      this.$refs.passowrd.show()
    },
    getMsgFormSon() {
      this.msgFormSon = data
    },
    loginOut() {
      let userName = window.localStorage.getItem('userNameZ')
      let pwdZ = window.localStorage.getItem('pwdZ')
      this.$utils.delAllStorage()
      this.$utils.delAllSession()
      if (userName && userName != null) {
        window.localStorage.setItem('userNameZ', userName)
        window.localStorage.setItem('pwdZ', pwdZ)
      }
      this.$router.push({
        name: 'login'
      })
      this.$toaster.ok('退出成功')
    },

    //更多
    moreBth() {
      this.homePageIsShow = false
      this.colorShow = 7
    },
    backHome() {
      this.homePageIsShow = !this.homePageIsShow
      this.colorShow = 1
    },
    changeMenuStatus(data) {
      // 控制菜单折叠与展开
      this.isCollapse = !this.isCollapse
      this.$refs.sideMenu.controlMenuStatus() // 调用子组件的方法
    },
    titleShow(id) {
      this.colorShow = id
    },
    getTo() {
      let url = 'http://192.168.1.112:8080/intelligent_three_dimensional/#/./?Authorization=' + store.state.user.token
      // window.open = url;
      this.colorShow = 5
      window.open(`${url}`, '_blank')
    },
    changePositionTitle(currentPath) {
      console.log(currentPath, 'currentPath')
      if (currentPath == '/homePage' || currentPath == '/cropsManagement') {
        this.colorShow = 1
      } else if (currentPath == '/dataAnalysisManagement') {
        this.colorShow = 5
      } else if (currentPath == '/intelligentControl') {
        this.colorShow = 2
      } else if (currentPath == '/fertilizerManagement') {
        this.colorShow = 3
      } else if (currentPath == '/growthModelManagement') {
        this.colorShow = 4
      } else if (currentPath == '/alarmPredictions') {
        this.colorShow = 7
      } else if (currentPath == '/decisionManagement') {
        this.colorShow = 8
      } else if (currentPath == '/cropsManagement') {
        this.colorShow = 9
      } else if (currentPath == '/deviceManagement') {
        this.colorShow = 10
      } else if (currentPath == '/approval') {
        this.colorShow = 11
      } else if (currentPath == '/userManagement') {
        this.colorShow = 12
      } else if (currentPath == '/greenhouseManagement') {
        this.colorShow = 5
      } else if (currentPath == '/regionalMapManagement') {
        this.colorShow = 5
      } else if (currentPath == '/irrigationRecordManagement') {
        this.colorShow = 3
      } else if (currentPath == '/groupFarm') {
        this.colorShow = 14
      } else if (currentPath == '/timedTask') {
        this.colorShow = 15
      } else if (currentPath == '/growthModelHisParamControlChart') {
        this.colorShow = 13
      } else if (currentPath == '/aiModal') {
        this.colorShow = 20
      }

      if (this.colorShow > 5) {
        this.homePageIsShow = false
      }

      // currentPath 刷新页面时，是string  路由切换时是 Array
      if (typeof currentPath == 'string') {
        this.currentPath = currentPath
      } else {
        this.currentPath = currentPath[1]
      }

      let arr = []

      let routerData = this.$router.options.routes

      if (typeof currentPath == 'string') {
        // 根据路由信息，匹配相应的路由内容，生成面包屑
        // 总路由 -- 一级路由
        for (let i = 0, len = routerData.length; i < len; i++) {
          // 二级路由
          for (let j = 0, leng = routerData[i].children ? routerData[i].children.length : 0; j < leng; j++) {
            // 三级路由
            if (routerData[i].children[j].children) {
              for (let k = 0, klen = routerData[i].children[j].children ? routerData[i].children[j].children.length : 0; k < klen; k++) {
                if (currentPath == routerData[i].children[j].children[k].path) {
                  arr.push(routerData[i].children[j]) // 选中上级路由
                  arr.push(routerData[i].children[j].children[k]) // 本级路由
                }
              }
            } else {
              if (currentPath == routerData[i].children[j].path) {
                arr.push(routerData[i].children[j]) // 选中上级路由
              }
            }
          }
        }
      } else {
        // 根据路由信息，匹配相应的路由内容，生成面包屑
        // 总路由 -- 一级路由
        for (let i = 0, len = routerData.length; i < len; i++) {
          // 二级路由
          for (let j = 0, leng = routerData[i].children ? routerData[i].children.length : 0; j < leng; j++) {
            if (currentPath[0] == routerData[i].children[j].path) {
              arr.push(routerData[i].children[j])
              // 三级路由
              for (let k = 0, klen = routerData[i].children[j].children ? routerData[i].children[j].children.length : 0; k < klen; k++) {
                if (currentPath[1] == routerData[i].children[j].children[k].path) {
                  arr.push(routerData[i].children[j].children[k])
                }
              }
            }
          }
        }
      }

      this.positionData = arr
    },
    // 菜单点击回调事件
    handleSelect() {},
    permissionJudge() {
      // 权限判断
      this.permission = this.$utils.getSession('PERMISSION')
      if (this.$utils.getSession('PERMISSION')) {
      } else {
        this.isAdmin = true
      }
    }
  },
  mounted() {
    // 页面加载，选中当前页对应的导航
    var routePath = this.$route.path
    this.changePositionTitle(routePath)
    let _this = this // 声明一个变量指向Vue实例this，保证作用域一致
    this.timer = setInterval(() => {
      _this.date = new Date() // 修改数据date
    }, 1000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer) // 在Vue实例销毁前，清除我们的定时器
    }
  }
}
</script>
<style lang="scss">
.el-menu-demo {
  height: 45px;
  line-height: 30px;
  color: #ffffff !important;
  background: linear-gradient(180deg, #49acff 0%, #0073d4 100%);
}

.logo-img-top {
  width: 200px;
  margin-right: 10px;
  margin-left: 15px;
}

#layout {
  // height: 100vh;
  width: 100vw;
  // overflow: hidden;

  .el-header {
    padding-left: 0px;
    padding-right: 0px;

    .header-left_icon {
      padding: 25px 0 0 0;
      margin-right: 10px;
    }
  }

  .commont-header-container {
    display: flex;
    justify-content: space-between;
    min-height: 110px !important;
    margin-bottom: 1rem;
  }

  .el-main {
    padding: 0;
  }

  // 头部
  .logo-container {
    background-color: #2494f2;
    width: 100%;
    // height: 80px;
    height: 60px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    justify-content: space-between;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    // -webkit-justify-content: center;
    // justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    flex-direction: row;

    // 左侧logo
    .header-left_icon {
      height: 80px;
    }

    // 中间切换栏
    .header-center_tab {
      display: flex;
      flex: 1;
      height: 60px;

      .el-menu {
        width: 100%;
        vertical-align: middle;
        display: flex;
        // margin-top: 24px;
        border: 0;
        // background-color: transparent !important;

        .el-menu-item {
          margin-left: -10px;
          flex: 1;
          // background: url(~@/static/img/2.png) no-repeat 0 1px;
          // background-size: 100% 100%;
          // width: 16.66%;
          height: 45px !important;
          line-height: 45px !important;
          text-align: center;
          border-radius: 5px 0 0 0;
          color: #707070;
          // border-bottom: 5px solid #236cff !important;
          border-radius: 0 0 0 12px;

          .el-menu-item i {
            // display: inline-block;
            // width: 16px;
            // height: 16px;
          }

          // img {
          //   width: 16px;
          //   height: 16px;
          // }
        }
      }
    }

    // 右边时间用户
    .header-right_content {
      width: 480px;
      height: 60px;
      display: flex;
      color: #ffffff;
      .header_title {
        line-height: 60px;
        margin-right: 1rem;
      }

      .header-current_time {
        // width: 164px;
        height: 60px;
        line-height: 60px;
        text-align: center;
        font-weight: bold;
        font-family: MicrosoftYaHei;
        width: 200px;
      }

      .header-right_user {
        // flex: 1;
        display: flex;
        align-items: center;

        .user-head_portrait {
          width: 37px;
          height: 37px;
          margin: 0 2px;
          background-color: red;
          border-radius: 18px;
        }

        .user-fun-container {
          cursor: pointer;
          margin-left: 2px;
          font-family: MicrosoftYaHei;
        }
      }
    }

    .logo-img {
      width: 40px;
      height: 44px;
    }

    .logo-title {
      font-size: 24px;
      color: #ffffff !important;
      margin-left: 16px;
    }
  }
}

.mainrig-content {
  .__view {
    max-width: 100%;
    height: 100%;
  }
}

// 有些乱
#layout > .el-container {
  height: 100%;
}

#layout > .el-container > .el-container {
  height: 100%;
  position: relative;
}

#layout > .el-container > .el-container > .el-main > .router-view-container {
  background: transparent;
}

.zx-status {
  color: #84d281 !important;
}

.borderLr {
  border-left: 1px solid #6fbcff !important;
  border-right: 1px solid #6fbcff !important;
}

.iconfont {
  top: -1px;
  right: 4px;
}

.icon-yujing {
  color: #707070 !important;
}

.spanmat {
  margin: 0 3px 0 10px !important;
}

.el-link {
  .el-link--inner {
    font-size: 12px;
    color: #4180fd;
  }
}

.user-header-img {
  cursor: pointer;
}

::v-deep .el-menu-item {
  height: 45px !important;
  line-height: 45px !important;
}

::v-deep .el_item {
  height: 45px !important;
  line-height: 45px !important;
}

.home_item {
  display: flex;
  justify-content: center;
  margin-top: 0.4rem;
  border-radius: 5px;
  width: 5.5rem !important;
  height: 2rem !important;
  line-height: 2.2rem !important;
  color: #ffffff;
}

.home_item:hover {
  color: #ffffff !important;
  z-index: 10 !important;
  background-color: rgba($color: #0a6ff3, $alpha: 0.7);
}

.colorShow {
  color: #0677d7 !important;
  background-color: #ffffff;
  z-index: 10 !important;
}
</style>
